import FieldRenderer from "./FieldRenderer";

const FormBody = ({
  id,
  formData,
  activeTabIndex,
  handleChange,
  signatureRefs,
  draftSignatures,
  setDraftSignatures,
}) => {
  const tab = formData[activeTabIndex];

  if (!tab || !tab.content) return null;

  return (
    <div className="space-y-6 px-4 py-2">
      {tab.content.map((item, index) => {
        const refKey = `tab${activeTabIndex}-field${index}`;
        return (
          <FieldRenderer
            key={refKey}
            id={id}
            item={item}
            index={index}
            refKey={refKey}
            formData={tab.content}
            handleChange={handleChange}
            signatureRefs={signatureRefs}
            draftSignatures={draftSignatures}
            setDraftSignatures={setDraftSignatures}
          />
        );
      })}
    </div>
  );
};

export default FormBody;
